import React, { useState } from "react";
import { MdHomeRepairService, MdOutlineMedicalServices } from "react-icons/md";
import { AppstoreOutlined } from "@ant-design/icons";
import ServicesScreen from "../Services/Services";
import PackagesManagement from "../PackagesScreen/PackageScreen";
import CouponsScreen from "../CouponsScreen/CouponsScreen";
import { RiCouponLine } from "react-icons/ri";

const role=localStorage.getItem("role");
const TABS = [
  {
    key: "services",
    label: "My Services",
    icon: <MdOutlineMedicalServices className="text-lg" />,
    component: <ServicesScreen />,
  },
  {
    key: "packages",
    label: "My Packages",
    icon: <AppstoreOutlined />,
    component: <PackagesManagement />,
  },
  role==3&&{
    key: "coupons",
    label: "My Coupons",
    icon: <RiCouponLine />,
    component: <CouponsScreen />,
  },
];

export default function ServicesAndPackages() {
  const [activeTab, setActiveTab] = useState("services");

  const active = TABS.find((t) => t.key === activeTab);

  return (
    <div className="min-h-screen bg-[#F7FCFD]">
      {/* Tab Bar */}
      <div className="bg-white border-b border-gray-200 px-6 pt-4">
        <div className="flex gap-1">
          {TABS.map((tab) => {
            const isActive = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={[
                  "flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-t-lg border-b-2 transition-all whitespace-nowrap",
                  isActive
                    ? "border-primary text-primary bg-primary/5"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                ].join(" ")}
              >
                <span>{tab.icon}</span>
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div>{active?.component}</div>
    </div>
  );
}